// src/pages/Reports/IssuanceReporting/shared/AgentSelect.tsx
// README.md mục 7 — dropdown chọn Đại lý dùng chung cho các báo cáo lọc theo AgentId (RPT-005/
// 006/007/008/009/011/012). Dùng lại helpers/agentLookup.ts (cache-first, đã kiểm chứng ở
// Reports/AgentDebtReport) — không tự gọi lại /system-api/Agent riêng ở đây.

import React, { useEffect, useState } from 'react';
import { Input } from 'reactstrap';

import { loadAgentsWithCache } from 'helpers/agentLookup';
import { IAgent } from 'slices/agentManagement/types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('reports_issuance_reporting');

interface AgentSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const AgentSelect: React.FC<AgentSelectProps> = ({ value, onChange, disabled = false }) => {
  const [agents, setAgents] = useState<IAgent[]>([]);

  useEffect(() => {
    loadAgentsWithCache().then(setAgents);
  }, []);

  return (
    <Input type="select" value={value} disabled={disabled} onChange={(event) => onChange(event.target.value)}>
      <option value="">{st('tat_ca_dai_ly_option')}</option>
      {agents.map((agent) => (
        <option key={agent.id} value={agent.id}>{agent.code} - {agent.name}</option>
      ))}
    </Input>
  );
};

export default AgentSelect;
